import { FormImage } from "./formImagesTypes";

export function removeItem(index: number, items: FormImage[]): FormImage[] {
    const newItems = [...items].filter((_, i) => i !== index);
    return [...newItems];
}

export function sortingItems(source: number, destination:number, items: FormImage[]): FormImage[] {
    const reorderedItem = items[source];
    const newItems = [...items];
    newItems.splice(source, 1);
    newItems.splice(destination, 0, reorderedItem);
    return [...newItems];
}